import { getPrioritizedArticleStatusProduct } from '../../../shared/utils/product/product';

import {
  PDP_MULTISTORE_NEARBY_DISTANCE,
  PDP_MULTISTORE_SELECTED_STORE_TYPE,
  PRODUCT_ALTERNATE_STOCK_STATUS,
  PRODUCT_STOCK_LEVEL,
  PRODUCT_STOCK_LEVEL_IS_FROM_MY_STORE,
  PRODUCT_STOCK_LEVEL_STORE_CODE
} from '../../../shared/constants/data-layer';

export function getPdpMultiStoreDataLayerValues(
  product,
  nearByStores,
  myStoreCode,
  selectedStoreCode
) {
  const articleStatusProduct = getPrioritizedArticleStatusProduct(
    product,
    product?.rearProduct
  );
  const productStockStatus =
    myStoreCode !== selectedStoreCode
      ? [articleStatusProduct?.nearByStoreStock?.availabilityMessage]
      : [product?.stock?.availabilityMessage];
  const storeCode =
    myStoreCode !== selectedStoreCode ? selectedStoreCode : myStoreCode;

  const productAlternateStockStatus =
    myStoreCode === selectedStoreCode
      ? [articleStatusProduct?.nearByStoreStock?.availabilityMessage]
      : [product?.stock?.availabilityMessage];

  const nearByStoreDistance =
    nearByStores
      ?.find(s => s?.code === articleStatusProduct?.nearByStoreStock?.storeCode)
      ?.distance?.toString() || '';
  const selectedMultiStoreType =
    myStoreCode === selectedStoreCode ? 'preferred' : 'nearby';
  const productStockIsFromMyStore = selectedStoreCode
    ? [myStoreCode === selectedStoreCode ? '1' : '0']
    : [''];
  return {
    [PDP_MULTISTORE_NEARBY_DISTANCE]: nearByStoreDistance,
    [PDP_MULTISTORE_SELECTED_STORE_TYPE]: selectedMultiStoreType,
    [PRODUCT_ALTERNATE_STOCK_STATUS]: productAlternateStockStatus,
    [PRODUCT_STOCK_LEVEL]: productStockStatus,
    [PRODUCT_STOCK_LEVEL_IS_FROM_MY_STORE]: productStockIsFromMyStore,
    [PRODUCT_STOCK_LEVEL_STORE_CODE]: [storeCode]
  };
}
